// The column picker used by the output settings. (The Roadmap 1 form for
// built-in step parameters was removed with those steps; it is kept at the
// tag roadmap-1-final.)
import { Select } from "antd";
import { columnOptions } from "../../shared/display";

const filterOption = (input, option) => String(option?.label ?? "").toLowerCase().includes(input.toLowerCase());

export const ColumnSelect = ({ table, multiple, value, onChange, placeholder = "Choose column", allowClear }) => (
  <Select
    className="w-full"
    mode={multiple ? "multiple" : undefined}
    showSearch
    allowClear={allowClear}
    placeholder={placeholder}
    value={value ?? (multiple ? [] : undefined)}
    onChange={onChange}
    options={columnOptions(table)}
    filterOption={filterOption}
    notFoundContent={table ? "No columns" : "Input not available yet"}
  />
);
